import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const netbox = defineConnector({
  identifier: "netbox",
  name: "NetBox",
  tagLine: "Network source of truth",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ url }) => domainToRegex(url),
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In NetBox, navigate to your user profile and select **API Tokens**. Click **Add a token** and configure the permissions as needed.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "baseUrl",
          label: "NetBox URL",
          placeholder: "https://netbox.example.com",
          required: true,
          target: { kind: "configuration", field: "url" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ url }) => `${url}/api/status/`,
  },
});
